"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CharacterSetECI_1 = require("../common/CharacterSetECI");
/**
 * Just to make a shortcut between Java code and TS code.
 */
var StandardCharsets = /** @class */ (function () {
    function StandardCharsets() {
    }
    StandardCharsets.ISO_8859_1 = CharacterSetECI_1.default.ISO8859_1;
    return StandardCharsets;
}());
exports.default = StandardCharsets;



//////////////////
// WEBPACK FOOTER
// ./~/@zxing/library/cjs/core/util/StandardCharsets.js
// module id = 241
// module chunks = 4